export default "__VITE_ASSET__Oemg0ScJ__"